import Schema from 'AppReact/schema';
import { tableOrder } from 'types';

export default {
  order: Schema(tableOrder, 'object', { defaultValue: {} }),
  isSelected: Schema('boolean', 'primitive', { defaultValue: false }),
  selectedTab: Schema('string', 'primitive', { defaultValue: '' })
}